import { gql } from "@apollo/client";

export const COMPANIES_QUERY = gql`
  query Companies {
    companies {
      id
    name
    email
    subdomain
    role
    parentCompanyId
    parentCompany {
      id
      name
      role
    }
    schemaName
    schemaStatus
    address
    city
    state
    country
    zip
    phoneNumber
    countryCode
    createdAt
    updatedAt
    website
    businessType
    industry
    aiEnabled
     owner {
            id
            email
            firstName
            lastName
            role
            active
            createdAt
            updatedAt
        }
    }
  }
`;

export const COMPANY_USERS_QUERY = gql`
 query CompanyUsers($filter: CompanyUsersFilter) {
    companyUsers(filter: $filter) {
        id
        email
        firstName
        lastName
        role
        companyId
        companyName
        schema
        subdomain
        twoFactorEnabled
        invitationStatus
        invitedBy
        invitedOn
        active
        deletedAt
        phoneNumber
        countryCode
        
    }
}`;

// Users Query (deprecated - use COMPANY_USERS_QUERY instead)

// Partners Query
